import axios from 'axios';
import config from '../config';
import Vue from 'vue';

const eightCentresStore ={
  namespaced: true,
  state:{
    useList: [],
  },
  mutations:{

  },
  actions:{
    async insertOrUpdateDetail(context, {preObj,objList}) {
      
      const {userId, session,lang} = preObj;
    return new Promise(async (resolve, reject) => {
      try {
      let result = await axios.post(`${config.domain}/eightMajor/insertOrUpdateDetail?userId=${userId}&lang=${lang}&session=${session}`, objList)

      if (!result.data.errorCode || result.data.errorCode === 0) {
        resolve(result)
        } else {
        context.commit("setwarning", {
          string: result.data.errorMessage,
          boolean: true,
          button: [{
            name: "Cancel",
            callBack: function () {}
          }]
        }, { root: true })
        resolve(false)
        }
      } catch (err) {
      reject(err)
    }
  })
},
// store/modules/eightCentres.js
async searchDetail(context, params) {
  const { cancelToken, ...queryParams } = params || {};
  try {
    const result = await axios.get(`${config.domain}/eightMajor/searchDetail`, {
      params: queryParams,
      ...(cancelToken ? { cancelToken } : {}),
    });

    // If API indicates success (errorCode === 0) return the full axios response
    if (result && result.data && result.data.errorCode === 0) {
      return result;
    }

    // If API returned an errorCode, commit a warning but throw so caller can handle it
    context.commit(
      "setwarning",
      {
        string: (result && result.data && result.data.errorMessage) || "Unknown error",
        boolean: true,
        button: [{ name: "Cancel", callBack: function () {} }]
      },
      { root: true }
    );

    // Throw an Error so the component sees the failure and can log/handle it
    throw new Error((result && result.data && result.data.errorMessage) || "searchDetail returned errorCode");
  } catch (err) {
    if (axios.isCancel(err)) throw err;
    // Log and rethrow so callers (components) can inspect network/axios errors
    console.error("searchDetail action error:", err);
    throw err;
  }
},
async ifDetailExist(context, params) {
  return new Promise(async (resolve, reject) => {
    try {
      let result = await axios.get(`${config.domain}/eightMajor/ifDetailExist`, {
        params: params
      })

      if (!result.data.errorCode || result.data.errorCode === 0) {
        resolve(result)
      } else {
        context.commit("setwarning", {
          string: result.data.errorMessage,
          boolean: true,
          button: [{
            name: "Cancel",
            callBack: function () {}
          }]
        }, { root: true })
        resolve(false)
      }
    } catch (err) {
      reject(err)
    }
  })
},

async insertOrUpdateCentre(context, {preObj,objList}) {
  const {userId, session,lang} = preObj;
  try {
    let result = await axios.post(`${config.domain}/eightMajor/insertOrUpdateCentre?userId=${userId}&lang=${lang}&session=${session}`, objList);
    if (!result.data.errorCode || result.data.errorCode === 0) {
      return result;
    } else {
      context.commit("setwarning", { string: result.data.errorMessage, boolean: true }, { root: true });
      return false;
    }
  } catch (err) {
    throw err;
  }
}
,
async searchCentre(context, params) {
  return new Promise(async (resolve, reject) => {
    try {
      let result = await axios.get(`${config.domain}/eightMajor/searchCentre`, {
        params: params
      })

      if (!result.data.errorCode || result.data.errorCode === 0) {
        resolve(result)
      } else {
        context.commit("setwarning", {
          string: result.data.errorMessage,
          boolean: true,
          button: [{
            name: "Cancel",
            callBack: function () {}
          }]
        }, { root: true })
        resolve(false)
      }
    } catch (err) {
      reject(err)
    }
  })
},



  }
}
export default eightCentresStore;